/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_AriaInputs */

const en_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently asked questions about Alchema`)
};

const de_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haeufig gestellte Fragen zu Alchema`)
};

const fr_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions frequentes sur Alchema`)
};

const es_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes sobre Alchema`)
};

const it_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domande frequenti su Alchema`)
};

const nl_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veelgestelde vragen over Alchema`)
};

const pl_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czesto zadawane pytania o Alchema`)
};

const fi_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usein kysytyt kysymykset Alchemasta`)
};

const da_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofte stillede sporgsmal om Alchema`)
};

const sv_landing_faq_aria = /** @type {(inputs: Landing_Faq_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanliga fraagor om Alchema`)
};

/**
* | output |
* | --- |
* | "Frequently asked questions about Alchema" |
*
* @param {Landing_Faq_AriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_faq_aria = /** @type {((inputs?: Landing_Faq_AriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_AriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_faq_aria(inputs)
	if (locale === "fr") return fr_landing_faq_aria(inputs)
	if (locale === "es") return es_landing_faq_aria(inputs)
	if (locale === "it") return it_landing_faq_aria(inputs)
	if (locale === "nl") return nl_landing_faq_aria(inputs)
	if (locale === "pl") return pl_landing_faq_aria(inputs)
	if (locale === "fi") return fi_landing_faq_aria(inputs)
	if (locale === "da") return da_landing_faq_aria(inputs)
	if (locale === "sv") return sv_landing_faq_aria(inputs)
	return en_landing_faq_aria(inputs)
});